import Vue from 'vue';

const SET_ARTICLES = 'SET_ARTICLES';
const SET_ARTICLE = 'SET_ARTICLE';
const UNSET_ARTICLE = 'UNSET_ARTICLE';

export default {
  namespaced: true,
  state: {
    articles: null,
    article: null,
  },
  mutations: {
    /* eslint-disable no-param-reassign */
    [SET_ARTICLES](state, articles) {
      state.articles = articles;
    },
    [SET_ARTICLE](state, article) {
      state.article = article;
    },
    [UNSET_ARTICLE](state) {
      state.article = null;
    },
    /* eslint-enable no-param-reassign */
  },
  actions: {
    getArticles({ commit }, { page }) {
      return Vue.axios.get('articles', {
        params: { page },
      }).then(({ data }) => commit(SET_ARTICLES, data));
    },
    getArticle({ commit }, id) {
      return Vue.axios.get(`articles/${id}`)
        .then(({ data }) => commit(SET_ARTICLE, data));
    },
    unsetArticle({ commit }) {
      commit(SET_ARTICLE);
    },
    saveArticle({ commit }, data) {
      const { id } = data;
      const method = id ? 'put' : 'post';
      const url = id ? `articles/${id}` : 'articles';

      return Vue.axios({
        method,
        url,
        data,
      }).then((response) => {
        commit(SET_ARTICLE, response.data);
        return new Promise(resolve => resolve(response.data));
      });
    },
    saveArticleAssets(context, { id, params }) {
      return Vue.axios.put(`articles/${id}/assets`, params);
    },
    saveArticleMeta(context, { id, params }) {
      return Vue.axios.put(`articles/${id}/meta`, params);
    },
    deleteArticle(context, id) {
      return Vue.axios.delete(`articles/${id}`);
    },
  },
  getters: {
    articles: state => state.articles,
    article: state => state.article,
  },
};
